import React from 'react';

export default function StatusCardPanel({ todayStatus, LIGHT_COLORS, fmt }) {
  if (!todayStatus || !todayStatus.scenarios) return null;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
      {todayStatus.scenarios.map(sc => {
        const l = LIGHT_COLORS[sc.trafficLight] || LIGHT_COLORS.gray;
        return (
          <div key={sc.id} style={{ borderLeft: `3px solid ${l.border}`, background: '#fff', padding: '8px 10px', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
              <span style={{ background: l.bg, color: l.text, width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', fontSize: '12px' }}>{l.emoji}</span>
              <span style={{ fontSize: '12px', color: '#555' }}>{sc.name}</span>
            </div>
            <div style={{ fontSize: '20px', fontWeight: 600, color: '#333' }}>{fmt(sc.avgResponseSec)}<span style={{ fontSize: '10px', color: '#999' }}>s</span></div>
            <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>🧑‍💻 {Number(sc.avgOnline).toFixed(0)}<span style={{ fontSize: '10px', color: '#999' }}> 在线</span></div>
          </div>
        );
      })}
    </div>
  );
}
